import { InputAdornment } from '@mui/material';

import { GDMInputAdornmentComponent } from './GDMInputAdornment.type';

/* TODO: Implement component using GDM default design */
const GDMInputAdornment: GDMInputAdornmentComponent = props => <InputAdornment {...props} />;

export default GDMInputAdornment;
